<template>
  <div>
    <PageAllow controller="StockIns" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4" v-if="pageType == 1">
          <v-row dense align="center" class="pa-1 pe-2">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
              deleteIcon
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="4" v-else>
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('StockOrderIN.Fields.created_time')"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
                v-if="$permission.permissionAllow('StockIns', 'batchIn')"
                small
                color="warning"
                class="ms-1 float-end"
                @click="batchInDialog = true"
            >
              <v-icon x-small class="pe-1">fa-align-justify</v-icon>
              {{ $t("StockOrderIN.actions.batchIn") }}
            </v-btn>
            <!-- 批量导出 -->
            <v-menu
              v-model="exportBtnMenu"
              open-on-hover
              close-on-click
              close-on-content-click
              offset-y
              v-if="
                $permission.permissionAllow('StockIns', 'batchDetailExport')
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  color="print"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ms-1 float-end"
                >
                  <v-icon x-small class="pe-1">fa-file-export</v-icon>
                  {{ $t("Export.batchExport") }}
                  <v-icon x-small class="ps-1">{{
                    exportBtnMenu ? "fa-caret-up" : "fa-caret-down"
                  }}</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-if="
                    $permission.permissionAllow('StockIns', 'batchDetailExport')
                  "
                  @click="batchDetailExport()"
                >
                  <v-list-item-title>
                    {{ $t("Export.export", [$t("StockOrderIN.ObjectName")]) }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- 批量打印 -->
            <v-menu
              v-model="printBtnMenu"
              open-on-hover
              close-on-click
              close-on-content-click
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="print"
                  class="ms-1 float-end"
                  @click.stop=""
                >
                  <v-icon x-small class="pe-1">fa-print</v-icon>
                  {{ $t("Print.batchPrint") }}
                  <v-icon x-small class="ps-1">
                    {{ printBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                  </v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click.stop="doPrint('stockOrdersInPrint')">
                  <v-list-item-title>
                    {{ $t("StockOrderIN.actions.stockOrderInBatchPrint") }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- 批量云打印 -->
            <v-menu
              v-if="settings && settings.cloud_print_enable"
              v-model="cloudPrintBtnMenu"
              open-on-hover
              close-on-click
              close-on-content-click
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="print"
                  class="ms-1 float-end"
                  @click.stop=""
                >
                  <v-icon x-small class="pe-1">fa-print</v-icon>
                  {{ $t("Print.batch_cloud_print") }}
                  <v-icon x-small class="ps-1">
                    {{ cloudPrintBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                  </v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click.stop="doCloudPrint('stockOrderIn')">
                  <v-list-item-title>
                    {{ $t("StockOrderIN.actions.stockOrderInBatchPrint") }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn
              v-if="
                $permission.permissionAllow('StockIns', 'add') && pageType != 3
              "
              small
              color="primary"
              href="/#/stock-orders-in/new"
              class="ms-1 float-end"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.newInfo", [$t("StockOrderIN.ObjectName")]) }}
            </v-btn>
            <v-btn
              v-if="$permission.permissionAllow('StockIns', 'prints')"
              small
              color="print"
              dark
              class="ms-1 float-end"
            >
              <v-icon x-small class="pe-1">fa-file-export</v-icon>
              {{ $t("Export.export", [$t("StockOrderIN.ObjectName")]) }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="stock_order_code"
                  v-model="options.stock_order_code"
                  @text="stockInsKeyWord = $event"
                  :label="
                    stockInTypeSelected == 11
                      ? $t('StockOrderIN.stockInsKeyword_two')
                      : $t('StockOrderIN.stockInsKeyword')
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="pageType == 1">
                <SearcherKeyword
                  ref="ext_code"
                  v-model="options.ext_code"
                  @text="extCodeKeyword = $event"
                  :label="$t('StockOrderIN.Fields.ext_code')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStock v-model="stockSelected" :stock-types="[0]" />
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="pageType == 1">
                <v-select
                  v-model="stockInTypeSelected"
                  clearable
                  :items="
                    $consts.stock_in_order.types.filter(
                      (element) => element.value != 4
                    )
                  "
                  :label="$t('StockOrderIN.Fields.stock_in_type')"
                >
                </v-select>
              </v-col>
              <!-- !!! -->
              <v-col cols="12" sm="6" md="4" v-if="pageType == 1">
                <SearcherKeyword
                  ref="stock_in_obj_name"
                  v-model="options.obj_name"
                  @text="objNameKeyword = $event"
                  :label="$t('StockOrderIN.Fields.stock_in_obj_name')"
                />
              </v-col>
              <!-- 商品 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterials v-model="materialSelected" />
              </v-col>
              <!-- !!! -->
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :label="$t('StockOrderIN.status.title')"
                  :items="
                    pageType == 1
                      ? $consts.stock_in_order.status
                      : [
                          $consts.stock_in_order.status[1],
                          $consts.stock_in_order.status[2],
                        ]
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherCancelFlgs v-model="options.cancel_flgs" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="stock_ins"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:header.stock_order_code="{ header }">
            <span v-if="options.datetimeRadioSelected == 'created'">
              {{ header.text }}
            </span>
            <span v-else>
              {{
                $t("StockOrderIN.Fields.stock_in_code") +
                " / " +
                $t("StockOrderIN.Fields.actual_time")
              }}
            </span>
          </template>

          <template v-slot:item.stock_order_code="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.stock_order_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{
                options.datetimeRadioSelected == "created"
                  ? item.created
                  : item.actual_date | formatTime
              }}
            </span>
          </template>
          <template v-slot:item.type="{ item }">
            <v-chip
              small
              label
              :color="item.type | stockOrderINTypesColor"
              :text-color="item.type | stockOrderINTypesTextColor"
            >
              {{ item.type | stockOrderINTypesText }}
            </v-chip>
            <br />
            <a
              v-if="item.type == 11"
              class="text-no-wrap text-caption"
              :href="
                '/#/purchases/detail/0' + '?' + 'code=' + item.purchase_code
              "
              style="text-decoration: none"
            >
              {{ item.purchase_code }}
            </a>
            <a
              v-if="item.type == 1 && item.order_code"
              class="text-no-wrap text-caption"
              :href="'/#/return-orders/' + item.order_id"
              style="text-decoration: none"
            >
              {{ item.order_code }}
            </a>
            <a
              v-if="item.type == 2 && item.in_requisition && item.in_requisition.requisition_code"
              class="text-no-wrap text-caption"
              :href="'/#/requisitions/' + item.in_requisition.id"
              style="text-decoration: none"
            >
              {{ item.in_requisition.requisition_code }}
            </a>
          </template>
          <template v-slot:item.status="{ item, index }">
            <span :v-resize="!index ? $stickTableResizer() : null"> </span>
            <v-chip
              small
              label
              :color="item.status | stockOrderINStatusColor"
              :text-color="item.status | stockOrderINStatusTextColor"
            >
              {{ item.status | stockOrderINStatusText }}
            </v-chip>
            <br />
            <v-chip
              v-if="item.cancel_flg"
              x-small
              label
              outlined
              color="danger"
            >
              {{ $t("CRUD.cancelled") }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <StockOrderINActions
              :productionFlg="pageType == 3"
              :stock_in="item"
              showView
              showEdit
              showApprove
              showCancel
              showComplete
              showShelve
              showBatchShelve
              showPrint
              @done="getStockInsFromAPI()"
              @shelveOnBatch="
                stock_in_shelve_on = $event;
                positionSelectedAlert = true;
              "
            />
          </template>
          <template v-slot:item.print_count="{ item }">
            <span v-if="item.print_count > 0" class="primary--text">
              {{ $t("StockOrderIN.Fields.printCount", [item.print_count]) }}
            </span>
            <span v-else class="red--text">
              {{ $t("StockOrderIN.Fields.printNone") }}
            </span>
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <v-dialog v-model="positionSelectedAlert" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("StockOrderIN.selectPosition") }}</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="positionSelectedAlert = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("StockOrderIN.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <SearcherStockPosition
              v-model="position"
              :stockId="stock_in_shelve_on ? stock_in_shelve_on.stock_id : 0"
              no-label
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            @click="positionSelectedAlert = false"
            >{{ $t("$vuetify.close") }}</v-btn
          >
          <v-btn color="accent" @click="shelveOnBatch()">{{
            $t("CRUD.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 批量入库 -->
    <DialogAlert
      v-model="batchInDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('StockOrderIN.Messages.batchInAlert')"
      persistent
      useConfirm
      @confirm="
        batchInDialog = false;
        batchInInfoDialog = true;
        batchIn(JSON.parse(JSON.stringify(options)));
      "
    />

    <BatchOperationInfoAlert
      v-model="batchInInfoDialog"
      :title="$t('$vuetify.alert')"
      :message="batchInInfo"
      persistent
      :closable="errorCount > 0"
    />
  </div>
</template>

<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import StockIns from "@/api/stock_ins";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import StockOrderINActions from "./plugins/Actions";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import SearcherStockPosition from "@/components/plugins/SearcherStockPosition";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import CloudPrintTemplates from "@/api/cloud_print_templates";
import DialogAlert from "@/components/plugins/DialogAlert.vue";
import BatchOperationInfoAlert from "@/components/orders/plugins/BatchOperationInfoAlert.vue";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  finish_time_from: "",
  finish_time_to: "",
  stock_order_code: "",
  obj_name: "",
  status: [1, 2],
  cancel_flgs: [0],
  type: null,
  stock_ids: null,
  material_ids: [],
};

const defaultProductionOptions = {
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  stock_order_code: "",
  obj_name: "",
  status: [2],
  cancel_flgs: [0],
  type: 4,
  stock_ids: null,
  material_ids: [],
};

function getPageType() {
  return document.URL.endsWith("/production-stock-in") ? 3 : 1;
}
function getOptionPrefix() {
  switch (getPageType()) {
    default:
    case 1:
      return "stock-orders-in";
    case 3:
      return "production-stock-in";
  }
}
function getOptionSelects() {
  switch (getPageType()) {
    default:
    case 1:
      return [
        "stockOutTypeSelected",
        "shopsSelected",
        "stockSelected",
        "districtsSelected",
        "materialSelected",
        "typeSelected",
      ];
    case 3:
      return ["stockSelected", "materialSelected"];
  }
}
function getDefaultOptions() {
  switch (getPageType()) {
    default:
    case 1:
      return defaultOptions;
    case 3:
      return defaultProductionOptions;
  }
}

export default {
  components: {
    BatchOperationInfoAlert,
    DialogAlert,
    PageAllow,
    Breadcrumbs,
    StockOrderINActions,
    SearcherDatetimeRange,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherStock,
    SearcherStatus,
    SearcherCancelFlgs,
    SearcherStockPosition,
    SearcherMaterials,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text:
            getPageType() == 3
              ? i18n.t("Nav.productionManagement")
              : i18n.t("Nav.stockManagement"),
          disabled: false,
          href: getPageType() == 3 ? "/production-plans" : "/stocks",
        },
        {
          text:
            getPageType() == 3
              ? i18n.t("Nav.productionStockIN")
              : i18n.t("Nav.stockOrdersIn"),
          disabled: true,
          href: "/stock-orders-in",
        },
      ];
    },
    headers() {
      return [
        {
          text:
            i18n.t("StockOrderIN.Fields.stock_in_code") +
            " / " +
            i18n.t("StockOrderIN.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: i18n.t("StockOrderIN.Fields.stock_in_obj_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "obj_name",
        },
        {
          text: i18n.t("StockOrderIN.Fields.stock_in_type"),
          align: "start",
          sortable: false,
          value: "type",
        },
        {
          text: i18n.t("StockOrderIN.Fields.stock_name"),
          align: "start",
          sortable: false,
          value: "stock.name",
        },
        {
          text: i18n.t("StockOrderIN.Fields.detail_count"),
          align: "start",
          sortable: false,
          value: "details_count",
        },
        {
          text: i18n.t("StockOrderIN.Fields.print_count"),
          align: "start",
          sortable: false,
          value: "print_count",
        },
        {
          text: i18n.t("StockOrderIN.Fields.status"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    datetimeRadios() {
      return [
        {
          key: "created",
          text: i18n.t("StockOrderOUT.Fields.created_time"),
        },
        {
          key: "actual",
          text: i18n.t("StockOrderOUT.Fields.actual_time"),
        },
        {
          key: "finish",
          text: i18n.t("StockOrderOUT.Fields.finished_time"),
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  data: () => ({
    pageType: getPageType(),
    stock_ins: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem(getOptionPrefix() + "-options")
        ? sessionStorage.getItem(getOptionPrefix() + "-options")
        : JSON.stringify(getDefaultOptions())
    ),
    stockInsKeyWord: "",
    extCodeKeyword: "",
    objNameKeyword: "",
    stockInTypeSelected: null,
    stockSelected: null,
    datetimeRage: [
      new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    positionSelectedAlert: false,
    position: {},
    stock_in_shelve_on: {},
    printBtnMenu: false,
    cloudPrintBtnMenu: false,
    exportBtnMenu: false,
    materialSelected: [],
    error_stock_in_id: [],
    errorCount: 0,
    successCount: 0,
    batchInDialog: false,
    batchInInfoDialog: false,
    batchInInfo: i18n.t("StockOrderIN.Messages.batchInInfo", [0, 0]),
    batchInErrorDialog: false,
    batchInErrorData: [],
    inStockOrder: [],
    alreadyInLength: 0,
  }),

  mounted() {
    this.$commonUtils.loadOptions(getOptionPrefix(), getOptionSelects()).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
          if (
            typeof this.options.created_time_from != "undefined" &&
            typeof this.options.created_time_to != "undefined"
          )
            this.datetimeRage = [
              this.options.created_time_from,
              this.options.created_time_to,
            ];
        } else this.resetSearch();

        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "stockSelected":
              this.stockSelected = selected.value;
              break;
            case "materialSelected":
              this.materialSelected = selected.value;
              break;
            case "typeSelected":
              if (getPageType() == 1) this.stockInTypeSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },

  methods: {
    resetSearch() {
      this.stockInTypeSelected = null;
      this.stockSelected = null;
      this.materialSelected = [];
      this.datetimeRage = [
        new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      //重置options
      this.options = JSON.parse(JSON.stringify(getDefaultOptions()));
      //重置搜索框
      let clearArr = [this.$refs.stock_order_code];
      if (getPageType() != 3) clearArr.push(this.$refs.ext_code);
      clearArr.forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        stock_order_code: this.stockInsKeyWord,
        obj_name: this.objNameKeyword,
      });
    },
    getStockInsFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        options.datetimeRadioSelected &&
        options.datetimeRadioSelected == "actual"
      ) {
        options.actual_date_from = this.options.actual_time_from;
        options.actual_date_to = this.options.actual_time_to;
      }
      StockIns.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_ins = response.data.stock_ins;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    shelveOnBatch() {
      this.$store.dispatch("fullscreenLoading");
      StockIns.shelveOnBatch({
        stock_order_id: this.stock_in_shelve_on.id,
        stock_position_id: this.position.id,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$store.dispatch("fullscreenLoadingStop");
              this.positionSelectedAlert = false;
              this.getStockInsFromAPI();
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          var options = JSON.parse(JSON.stringify(this.options));
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          switch (mode) {
            case "stockOrdersInPrint":
              this.$router.push({
                path: "/print/stock-orders-in-print",
                query: options,
              });
              break;
          }
        }.bind(this)
      );
    },
    doCloudPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          let options = JSON.parse(JSON.stringify(this.options));
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          if (mode == "stockOrderIn") {
            //获取单据详情
            StockIns.stockOrdersInPrint(options).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let stockOrdersIn = response.data.stock_ins;
                  stockOrdersIn.forEach((stockOrder) => {
                    stockOrder.stock_order_details.map((detail) => {
                      if (detail.negotiate_price_flg == 1) {
                        // 显示后议价
                        detail.price = this.$t(
                          "PurchasesDetail.purchaseFields.negotiatePrices"
                        );
                      }
                      return detail;
                    });
                  });
                  CloudPrintTemplates.batchPrint({
                    print_template_code: mode,
                    objects: stockOrdersIn,
                  });
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    batchDetailExport() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        options.datetimeRadioSelected &&
        options.datetimeRadioSelected == "actual"
      ) {
        options.actual_date_from = this.options.actual_time_from;
        options.actual_date_to = this.options.actual_time_to;
      }
      StockIns.batchDetailExport(options);
    },
    batchIn(options) {
      if (this.error_stock_in_id.length) {
        options.no_stock_in_ids = this.error_stock_in_id;
      }
      StockIns.batchIn(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.in_flg) {
              ++this.successCount;
            } else {
              this.error_stock_in_id.push(response.data.stock_in_id);
              ++this.errorCount;
            }
          } else {
            if (response.data.error.code != "ERR333") {
              this.error_stock_in_id.push(response.data.stock_in_id);
              ++this.errorCount;
              // if (response.data.error.code == "ERR668") {
              //   this.batchInErrorData.push(response.data.data[0]);
              //   this.batchInErrorDialog = true;
              // }
            } else {
              this.getStockInsFromAPI();
              options = null;
              this.error_stock_in_id = [];
              this.successCount = 0;
              this.errorCount = 0;
              this.alreadyInLength = 0;
              this.batchInInfoDialog = false;
            }
          }
          //去除本次入库的单子
          this.inStockOrder.splice(0, 1);
          //实时计数
          this.batchInInfo = i18n.t("StockOrderIN.Messages.batchInInfo", [
            this.successCount,
            this.errorCount,
          ]);
          ++this.alreadyInLength; //计已入库的单子总数
          if (
              response.data.status.isOK() ||
              response.data.error.code != "ERR333"
          ) {
            //回调
            this.batchIn(options);
          }
        }.bind(this)
      );
    }
  },

  watch: {
    $route: {
      handler() {
        this.$commonUtils
          .loadOptions(getOptionPrefix(), getOptionSelects())
          .then(
            function (data) {
              if (data.options) {
                this.options = data.options;
                if (
                  typeof this.options.created_time_from != "undefined" &&
                  typeof this.options.created_time_to != "undefined"
                )
                  this.datetimeRage = [
                    this.options.created_time_from,
                    this.options.created_time_to,
                  ];
              } else this.resetSearch();

              data.selecteds.forEach((selected) => {
                switch (selected.key) {
                  case "stockSelected":
                    this.stockSelected = selected.value;
                    break;
                  case "materialSelected":
                    this.materialSelected = selected.value;
                    break;
                  case "typeSelected":
                    if (getPageType() == 1)
                      this.stockInTypeSelected = selected.value;
                    break;
                }
              });
            }.bind(this)
          );
      },
    },
    options: {
      deep: true,
      handler() {
        this.getStockInsFromAPI();
        sessionStorage.setItem(
          getOptionPrefix() + "-options",
          JSON.stringify(this.options)
        );
      },
    },
    stockInTypeSelected: {
      handler() {
        if (getPageType() == 1) {
          this.options.type = this.stockInTypeSelected
            ? this.stockInTypeSelected
            : "";
          sessionStorage.setItem(
            getOptionPrefix() + "-typeSelected",
            JSON.stringify(this.stockInTypeSelected)
          );
        } else {
          this.options.type = "";
        }
      },
    },
    stockSelected: {
      handler() {
        this.options.stock_ids = this.stockSelected
          ? this.stockSelected.id
          : "";
        sessionStorage.setItem(
          getOptionPrefix() + "-stockSelected",
          JSON.stringify(this.stockSelected)
        );
      },
    },
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          getOptionPrefix() + "-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
    positionSelectedAlert: {
      handler() {
        if (!this.positionSelectedAlert) {
          this.position = {};
        }
      },
    },
  },
};
</script>